"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.getParam=exports.getAllParams=exports.default=exports.IFRAME_STYLE=void 0;const getSrcUrl=()=>{const a=document.getElementById("chat-widget-1925");return a?a.src:null},getParam=a=>{const b=getSrcUrl();return b?new URL(b).searchParams.get(a):""};exports.getParam=getParam;const getAllParams=()=>{const a=getSrcUrl();return a?[...new URL(a).searchParams.entries()].map(a=>{let[b,c]=a;return{name:b,value:c}}).filter(a=>!["c","i","s"].includes(a.name)):[]};exports.getAllParams=getAllParams;const IFRAME_STYLE=exports.IFRAME_STYLE=`<style>
      @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700|Poppins:400,600,700&display=swap');

      * {
        font-family: 'Open Sans', sans-serif;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        margin-bottom: 0.25rem;
        font-size: 1.75em;
      }
      h2 {
        font-size: 1.25em;
        font-family: 'Poppins', sans-serif;
      }
      h3,
      h4,
      h5,
      h6 {
        font-family: 'Poppins', sans-serif;
      }

      body {
        margin: 0;
        padding-left: 2rem;
      }
      #root {
        height: 100%;
        padding-bottom: 1.5rem;
        padding-right: 1.5rem;
        box-sizing: border-box;
        display:flex;
        justify-content: flex-end;
        align-items:flex-end;
      }
      @media only screen and (max-width: 420px) {
        body, #root {
          padding: 0;
        }
      }
      // 250px is breakpoint for launcher mode
      @media only screen and (min-width: 250px) and (max-width: 420px) {
        #root > div:not(:nth-last-child(2)) {
          width:100vw;
          height:100vh;
          max-height:100vh;
        }
      }
    </style>`,generateIframe=function(){let a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:[];return`
  <head>
    <meta name="viewport" content="width=device-width,initial-scale=1.0">
    <meta name="client" content="${getParam("c")}">
    <meta name="identifier" content="${getParam("i")}">
    <meta name="setting" content="${getParam("s")}">
    <meta name="variables" content='${JSON.stringify(getAllParams())}'>
    ${window.location&&`<meta name="browser_url" content=${window.location.href}>`}
    <base target="_blank">
    ${IFRAME_STYLE}
  </head>
  <body>
    <div id="root"></div>
    ${a.map(a=>`<script src="${a}"></script>`).join(" ")}
  </body>
`};var _default=exports.default=generateIframe;